import { Link } from 'react-router-dom';
import { useMe } from '../hooks/useMe';
import { ShieldAlert } from 'lucide-react';

/** Where the banner and the verify-first notices send people. */
export const VERIFY_PATH = '/settings/account#emails-and-phones';

/**
 * At the top of every page while my account is unverified (019 R19, Q4):
 * what I can't do yet, and where to fix it. Gone as soon as a verification
 * is announced.
 */
export default function UnverifiedBanner() {
  const me = useMe();
  if (me.status !== 'ready' || me.data?.status !== 'unverified') return null;
  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-3 rounded-3xl bg-wood/15 px-5 py-3 text-sm text-foreground"
    >
      <ShieldAlert className="size-5 shrink-0 text-wood" aria-hidden="true" />
      <p className="min-w-0 flex-1">Verify an email or phone to invite, post or message.</p>
      <Link
        to={VERIFY_PATH}
        className="rounded-full bg-primary px-4 py-1.5 font-semibold text-primary-foreground hover:bg-primary/90"
      >
        Verify
      </Link>
    </div>
  );
}
